import { IWhitespaceMenuItem } from "@whitespace/whitespace-ui";
import { GlobalState } from "little-state-machine";

export const updateMenuItems = (
  state: GlobalState,
  menuItems: IWhitespaceMenuItem[] | undefined
) => ({
  ...state,
  menuItems
});
